import React, { useState, useEffect, useReducer, useRef } from "react";
import ScrollView from "devextreme-react/scroll-view";
import { Popup, Position } from "devextreme-react/popup";
import Button from "devextreme-react/button";
import { Tooltip } from "devextreme-react/tooltip";
import { custom } from "devextreme/ui/dialog";
import NEXUS_CONST from "../../common/constants";
import rpsReducer from "../../reducers/rps";
import * as action from "../../actions/rps";
import { useReactToPrint } from "react-to-print";
import AsyncCallHandler from "../../common/AsyncCallHandler";
import themes from "devextreme/ui/themes";
import Highcharts from "highcharts";
import HighchartsTheme from "./chartsTheme";
import moment from "moment";
import { get } from "../../common/utils";
import PrintContent from "./PrintOut";
import ConfirmedResultsRPS from "./ConfirmedResultsRPS";
import RootCauseAnalysis from "./RootCauseAnalysis";
import Solution from "./Solution";
import GeneralInfo from "./GeneralInfo";
import Actions from "./Actions";
import ReasonforAction from "./ReasonforAction";
import Completionplan from "./Completionplan";
import RapidExperiment from "./RapidExperiments";
import TargetState from "./TargetState";
import BreakdownProblem from "./BreakdownProblem";
import { postUserLog } from "../../actions/common";
import { isEmpty, isNumber } from "lodash";

const alertBox = (msg) =>
  custom({
    messageHtml: msg,
    showTitle: false,
  }).show();
const initialStates = { problemSolvingData: null, lastSavedTab: "0", rpsAllData: null };

const BackPage = (d) => {
  let { data } = d;
  const dateFormat = (d) => moment(d).format("MM/DD/YYYY");
  const owner = (c) => {
    let info = get("printInfoG");
    if (info && info.peopleList) {
      let v = info.peopleList.filter((d) => {
        if (d.employeeId == c) return d;
      });
      return v ? v[0].employeeName : c;
    }
    return c;
  };
  const coachName = (c) => {
    let info = get("printInfoG");
    if (info && info.approvers) {
      let v = info.approvers.filter((d) => {
        if (d.id == c) return d;
      });
      return v ? v[0].name : c;
    }
    return c;
  };
  const teamMem = (c) => {
    let memId = c ? c.split(";") : "";
    let teamList = [];
    let info = get("printInfoG");
    if (info && info.distinctUsers) {
      let v = info.distinctUsers.map((d) => {
        if (memId.indexOf(d.employeeID) > -1 || memId == d.employeeID) {
          teamList.push(d.employeeName);
        }
      });
      return teamList.join("; ");
    }
  };

  return (
    <table className="back-page">
      <tbody>
        <tr>
          <td>Process Owner</td>
          <td>{data && data.processOwner ? owner(data.processOwner) : ""}</td>
        </tr>
        <tr>
          <td>Approver</td>
          <td>{data && data.coach ? coachName(d.data.coach) : ""}</td>
        </tr>
        <tr>
          <td>Start Date</td>
          <td>{data && data.startDate ? dateFormat(d.data.startDate) : ""}</td>
        </tr>
        <tr>
          <td>Due Date</td>
          <td>{data && data.dueDate ? dateFormat(d.data.dueDate) : ""}</td>
        </tr>
        <tr>
          <td>Close Date</td>
          <td>{data && data.dueDate ? dateFormat(d.data.dueDate) : ""}</td>
        </tr>
        <tr>
          <td>Area to Solve</td>
          <td>{data && data.areaToSolve ? d.data.areaToSolve : ""}</td>
        </tr>
        <tr>
          <td>Problem to Solve</td>
          <td>{data && data.ptsVal ? d.data.ptsVal : ""}</td>
        </tr>
        <tr>
          <td>Team Members</td>
          <td>{data && data.teamMembers ? teamMem(d.data.teamMembers) : ""}</td>
        </tr>
      </tbody>
    </table>
  );
};

const SpsPrintContent = React.forwardRef((props, ref) => {
  return (
    <div ref={ref}>
      <div id="printSPSc" className="sps-content print-out-sps">
        <PrintContent spsId={props.id} title={props.title} />
        {/* <div className="box">{props.prevData.map((d, i) => <div className="items" key={i}>{ i}</div>)}</div>
                <div className="sps-content print-sps"><div className="box">{props.prevData.map((d, i) => <div className="items" key={i}>{ d}</div>)}</div></div>
                
                <div className="print-title">{props.title}</div>
                 <div className="b-box"> <div style={{ width: '80%', marginTop: "40%" }}><BackPage data={props.data} /></div></div> 
            */}
      </div>
    </div>
  );
});

const PrintSPS = (props) => {
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const handlePrintOut = () => {
    postUserLog({
      event: `SPS Print Preview`,
      data: {
        action: `Print Action for PS-${props.id}`,
        module: "Digital Tier",
        section: props.navigationOn,
        siteUId: props.siteId,
        widget: "Structured Problem Solving",
        tierId: props.tierId,
      },
    });
    themes.current("generic.dark");
    Highcharts.setOptions(HighchartsTheme.dark);
    document.documentElement.setAttribute("data-theme", "dark");
    setTimeout(() => {
      handlePrint();
    }, 200);
  };

  return (
    <div>
      <div
        title="Print"
        className="sps-step dx-fa-button-icon print-out-icon"
        onClick={handlePrintOut}
      >
        <i className="fas fa-print"></i>
      </div>
      <SpsPrintContent ref={componentRef} {...props} />
    </div>
  );
};

export default ({
  rpsID,
  closeShift,
  tierId,
  siteId,
  activeItem,
  data,
  activeAlert,
  isRail,
  isEditable,
}) => {
  const [state, dispatch] = useReducer(rpsReducer, initialStates);
  let { problemSolvingData, lastSavedTab, rpsAllData } = state;

  const [active, setActive] = useState(0);
  const [isPreview, setPreview] = useState(0);
  const [rcaStatus, setRcaStatus] = useState("");
  const [rootCauseAnalysis, setRootCauseAnalysis] = useState("");
  const [isOpen, setisOpen] = useState("0");
  const [htmlEditorValue, setHtmlEditorValue] = useState("");
  const [rpssId, setRPSSId] = useState(rpsID);
  const [savedRootCauseWB, setSavedRootCauseWB] = useState("");
  const loggedinUser = get("hid");

  const navigationOn =
    !isEmpty(data) && isNumber(activeItem)
      ? data[activeItem]?.title
      : "Master Rail";

  const isDataSaved = (i) => setVisited(i);
  useEffect(() => {
    if (rpssId) {
      action.fetchSpsInfo(dispatch, rpssId);
    }
  }, [isOpen, rpssId]);

  const getDefaultSteps = () => {
    return [
      {
        id: 0,
        txt: "G",
        title: "General Information",
        visited: 0,
        isOpen: true,
      },
      {
        id: 1,
        txt: "1",
        title: "Reason for Action",
        visited: 0,
        isSaved: false,
        isOpen: false,
      },
      {
        id: 2,
        txt: "2",
        title: "Breakdown the Problem",
        visited: 0,
        isSaved: false,
        isOpen: false,
      },
      {
        id: 3,
        txt: "3",
        title: "Target State",
        visited: 0,
        isSaved: false,
        isOpen: false,
      },
      {
        id: 4,
        txt: "4",
        title: "Root Cause Analysis",
        visited: 0,
        isSaved: false,
      },
      {
        id: 5,
        txt: "5",
        title: "Solution Approach",
        visited: 0,
        isSaved: false,
        isOpen: false,
      },
      {
        id: 6,
        txt: "6",
        title: "Rapid Experiments",
        visited: 0,
        isSaved: false,
        isOpen: false,
      },
      {
        id: 7,
        txt: "7",
        title: "Completion Plan",
        visited: 0,
        isSaved: false,
        isOpen: false,
      },
      {
        id: 8,
        txt: "8",
        title: "Confirmed Results",
        visited: 0,
        isSaved: false,
        isOpen: false,
      },
      {
        id: 9,
        txt: "9",
        title: "Insights & Actions",
        visited: 0,
        isSaved: false,
        isOpen: false,
      },
    ];
  };

  useEffect(() => {
    if (rpssId === null || rpssId === undefined) {
      setSteps(getDefaultSteps());
    }
  }, [rpssId]);

  //fetching Problem solving data
  useEffect(() => {
    if (rpssId !== null && rpssId !== undefined) {
      action.fetchProblemSovingDatabyId(dispatch, rpssId);
    }
    //this was created since DB calls are really slow(for next two IF conditions)
    if (parseInt(isOpen) === 5) {
      problemSolvingData.vsTabs[6].isOpen = true;
    }
    if (
      parseInt(isOpen) === 3 &&
      problemSolvingData.vsTabs[3].isOpen === false
    ) {
      problemSolvingData.vsTabs[3].isOpen = true;
    }
    if (
      parseInt(isOpen) === 2 &&
      problemSolvingData.vsTabs[2].isOpen === false
    ) {
      problemSolvingData.vsTabs[2].isOpen = true;
    }
    if (
      parseInt(isOpen) === 1 &&
      problemSolvingData.vsTabs[1].isOpen === false
    ) {
      problemSolvingData.vsTabs[1].isOpen = true;
    }
    if (
      parseInt(isOpen) == 6 &&
      problemSolvingData.vsTabs[7].isOpen == true &&
      problemSolvingData.vsTabs[7].isSaved == true
    ) {
      problemSolvingData.vsTabs[8].isOpen = true;
    }
    if (rpssId && problemSolvingData !== null) {
      let defaultSteps = getDefaultSteps();
      let newarray = defaultSteps.map((x) =>
        Object.assign(
          x,
          problemSolvingData.vsTabs.find((y) => y.tab == x.txt)
        )
      );

      setSteps(newarray);
    }
  }, [isOpen, rpssId, problemSolvingData]);

  useEffect(() => {
    // if (rpssId && problemSolvingData !== null) {
    //   let defaultSteps = getDefaultSteps();
    //   let newarray = defaultSteps.map((x) =>
    //     Object.assign(
    //       x,
    //       problemSolvingData.vsTabs.find((y) => y.tab == x.txt)
    //     )
    //   );
    //   setSteps(newarray);
    // }
  }, [problemSolvingData, rpssId, isOpen]);
  let spsContent = [];

  const handleHtmlEditorChange = (value) => {
    setHtmlEditorValue(value);
  };

  const saveSps = () => {
    setVisited(active);
  };

  spsContent[0] = (
    <div>
      <GeneralInfo
        siteId={siteId}
        tierId={tierId}
        data={data}
        activeItem={activeItem}
        setRPSSId={setRPSSId}
        setisOpen={setisOpen}
        rpsID={rpssId}
        handleSPSSave={saveSps}
        navigationOn={navigationOn}
      />
    </div>
  );
  spsContent[1] = (
    <div>
      <ReasonforAction
        siteId={siteId}
        tierId={tierId}
        data={data}
        handleSPSSave={saveSps}
        setisOpen={setisOpen}
        activeItem={activeItem}
        rpsID={rpssId}
        isDataSaved={isDataSaved}
        navigationOn={navigationOn}
      ></ReasonforAction>
    </div>
  );
  spsContent[2] = (
    <BreakdownProblem
      siteId={siteId}
      rpsID={rpssId}
      tierId={tierId}
      setisOpen={setisOpen}
      handleSPSSave={saveSps}
      navigationOn={navigationOn}
    ></BreakdownProblem>
  );
  spsContent[3] = (
    <TargetState
      rpsID={rpssId}
      setisOpen={setisOpen}
      handleSPSSave={saveSps}
      tierId={tierId}
      siteId={siteId}
      navigationOn={navigationOn}
    ></TargetState>
  );
  spsContent[4] = (
    <RootCauseAnalysis
      siteId={siteId}
      activeAlert={activeAlert}
      tierId={tierId}
      data={data}
      activeItem={activeItem}
      setisOpen={setisOpen}
      rcaStatus={rcaStatus}
      setRcaStatus={setRcaStatus}
      setRootCauseAnalysis={setRootCauseAnalysis}
      rootCauseAnalysis={rootCauseAnalysis}
      onHtmlEditorChange={handleHtmlEditorChange}
      onSaveRootCauseWB={setSavedRootCauseWB}
      active={active}
      rpsID={rpssId}
      handleSPSSave={saveSps}
      navigationOn={navigationOn}
    />
  );
  // spsContent[5] = (
  //   <div>
  //     <Solution
  //       siteId={siteId}
  //       setisOpen={setisOpen}
  //       rpsID={rpssId}
  //       handleSPSSave={saveSps}
  //       tierId={tierId}
  //       navigationOn={navigationOn}
  //     />
  //   </div>
  // );

  spsContent[5] = (
    <div>
      <Solution
        siteId={siteId}
        rpsID={rpssId}
        setisOpen={setisOpen}
        handleSPSSave={saveSps}
        chartId="chart_sa"
        tierId={tierId}
        navigationOn={navigationOn}
      />
    </div>
  );
  spsContent[6] = (
    <div>
      <RapidExperiment
        handleSPSSave={saveSps}
        rpsID={rpssId}
        tierId={tierId}
        setisOpen={setisOpen}
        siteId={siteId}
        navigationOn={navigationOn}
      ></RapidExperiment>
    </div>
  );
  spsContent[7] = (
    <div>
      <Completionplan
        siteId={siteId}
        tierId={tierId}
        data={data}
        setisOpen={setisOpen}
        activeItem={activeItem}
        handleSPSSave={saveSps}
        rpsID={rpssId}
        navigationOn={navigationOn}
      ></Completionplan>
    </div>
  );
  spsContent[8] = (
    <ConfirmedResultsRPS
      rpsID={rpssId}
      tierId={tierId}
      setisOpen={setisOpen}
      activeAlert={activeAlert}
      handleSPSSave={saveSps}
      navigationOn={navigationOn}
      chartId="chart_cr"
      siteId={siteId}
    />
  );
  spsContent[9] = (
    <Actions
      siteId={siteId}
      tierId={tierId}
      rpsID={rpssId}
      setisOpen={setisOpen}
      handleSPSSave={saveSps}
      closeShift={closeShift}
      loggedinUser={loggedinUser}
      navigationOn={navigationOn}
    />
  );

  const isVisited = (i) => {
    let item = getItem(i);
    return item.visited;
  };
  const moveNext = () => {
    if (rpssId !== null && rpssId !== undefined) {
      action.fetchProblemSovingDatabyId(dispatch, rpssId);

      let cnt = parseInt(active) + 1;
      let item = getItem(cnt);
      let presentItem = getItem(active);
      //when 9 is open it means G is open hence this criteria
      if (active === 9) {
        setActive(0);
      } else {
        if (item.isOpen === false && active === 7) {
          alertBox("You are not allowed to move next screen.");
        } else {
          if (presentItem.visited || item.isOpen) {
            let cnt = parseInt(active) + 1;
            setActive(cnt > 9 ? 0 : cnt);
            postUserLog({
              event: `Box ${cnt - 1 === 0 ? "G" : cnt - 1} - ${
                getDefaultSteps()[cnt - 1].title
              }`,
              data: {
                action: `Next selected on navigation for PS-${rpssId}`,
                module: "Digital Tier",
                section: navigationOn,
                siteUId: siteId,
                widget: "Structured Problem Solving",
                tierId,
              },
            });
          } else
            alertBox(
              "Please save the details in <b>" +
                presentItem.title +
                "</b> to move next."
            );
        }
      }
    } else {
      alertBox("Please save the details in Genral info to move forward");
    }
  };

  const movePrev = () => {
    let cnt = parseInt(active) - 1;
    cnt = cnt < 0 ? 9 : cnt;
    const tabvalue = problemSolvingData.vsTabs[cnt].isOpen;
    if (rpssId !== null) {
      isVisited(cnt) || tabvalue
        ? setActive(cnt)
        : alertBox("You are not allowed to move previous screen.");

      (isVisited(cnt) || tabvalue) &&
        postUserLog({
          event: `Box ${cnt + 1 === 0 ? "G" : cnt + 1} - ${
            getDefaultSteps()[cnt + 1].title
          } `,
          data: {
            action: `Previous selected on navigation for PS-${rpssId}`,
            module: "Digital Tier",
            section: navigationOn,
            siteUId: siteId,
            widget: "Structured Problem Solving",
            tierId,
          },
        });
    }
  };

  const onStepNav = (i) => {
    if (problemSolvingData !== null) {
      const tabvalue = rpssId ? problemSolvingData.vsTabs[i].isOpen : "";
      if (isVisited(i) || active == i) {
        setActive(i);
      } else {
        let j = i - 1;
        j = j < 0 ? 9 : j;
        if (rpssId !== null) {
          //special criteria
          if (
            (i === 7 || i === 9) &&
            problemSolvingData.vsTabs[2].isOpen === true
          ) {
            setActive(i);
            postUserLog({
              event: `Box ${i === 0 ? "G" : i} - ${
                getDefaultSteps()[i].title
              } `,
              data: {
                action: `Box ${
                  i === 0 ? "G" : i
                } selected on SPS box navigation for PS-${rpssId}`,
                module: "Digital Tier",
                section: navigationOn,
                siteUId: siteId,
                widget: "Structured Problem Solving",
                tierId,
              },
            });
          } else if (
            tabvalue
              ? (setActive(i),
                postUserLog({
                  event: `Box ${i === 0 ? "G" : i} - ${
                    getDefaultSteps()[i].title
                  } `,
                  data: {
                    action: `Box ${
                      i === 0 ? "G" : i
                    } selected on SPS box navigation for PS-${rpssId}`,
                    module: "Digital Tier",
                    section: navigationOn,
                    siteUId: siteId,
                    widget: "Structured Problem Solving",
                    tierId,
                  },
                }))
              : alertBox("Please Follow the Sequence")
          );
        } else {
          alertBox("Please Follow the Sequence");
        }
      }
    } else {
      alertBox("Please Follow the Sequence");
    }
  };

  const renderTitle = () => {
    return (
      <div className="sps-title-blk-c">
        <div className="sps-pop-title">{headerInfo()}</div>
        <div className="sps-pop-act">
          <Button
            type="normal"
            icon="fas fa-print"
            onClick={() => {
              setPreview(true);
              postUserLog({
                event: `Box ${active} - ${
                  getDefaultSteps()[active].title
                } Print`,
                data: {
                  action: `SPS Print Preview for PS-${rpssId}`,
                  module: "Digital Tier",
                  section: navigationOn,
                  siteUId: siteId,
                  widget: "Structured Problem Solving",
                  tierId,
                },
              });
            }}
          />
          <Button
            type="normal"
            icon="fas fa-times"
            onClick={() => closeShift(false)}
          />
        </div>
      </div>
    );
  };
  const headerInfo = () => {
    if (rpssId && problemSolvingData) {
      let { ptsVal, areaToSolve } = problemSolvingData;
      areaToSolve = areaToSolve ? `Issue in ${areaToSolve}` : "";
      return `PS-${rpssId}: ${ptsVal} ${areaToSolve}`;
    } else return "Structured Problem Solving";
  };

  const PreviweSps = () => {
    let prevData = [
      spsContent[1],
      spsContent[4],
      spsContent[7],
      spsContent[2],
      <div>
        <Solution
          siteId={siteId}
          rpsID={rpssId}
          handleSPSSave={saveSps}
          chartId="chart_sa_p"
          tierId={tierId}
          navigationOn={navigationOn}
        />
      </div>,
      <ConfirmedResultsRPS
        rpsID={rpssId}
        tierId={tierId}
        activeAlert={activeAlert}
        handleSPSSave={saveSps}
        chartId="chart_cr_p"
      />,
      spsContent[3],
      spsContent[6],
      spsContent[9],
    ];
    return (
      <div className="sps-preview">
        <Popup
          visible={true}
          onHiding={() => setPreview(false)}
          dragEnabled={false}
          showCloseButton={true}
          showTitle={true}
          title={headerInfo() + " - Print Preview"}
          fullScreen={true}
        >
          <ScrollView width="100%" height="95%">
            <Position at="center" my="center" />
            <div>
              <PrintSPS
                data={problemSolvingData}
                prevData={prevData}
                title={headerInfo()}
                id={rpssId}
                siteId={siteId}
                tierId={tierId}
              />
              {/*<div id="printSPSc" className="sps-content print-sps">
                                <div className="box">{prevData.map((d, i) => <div className="items" key={i}>{d}</div>)}</div>
                               
                            </div> */}
            </div>
          </ScrollView>
        </Popup>
      </div>
    );
  };

  const getItem = (id) => spsSteps.find((d) => d.id == id);

  const [spsSteps, setSteps] = useState(getDefaultSteps());
  const isActive = (d) => (d.id == active ? " active" : "");
  const getState = (d) =>
    d.txt === "G"
      ? " visited"
      : d.visited || d.isOpen
      ? " visited"
      : " in-active";

  const setVisited = (id) => {
    if (rpssId !== null) {
      setSteps(
        spsSteps.map((d) => {
          if (d.id == id) {
            d.visited = 1;
            d.isSaved = true;
          }
          return d;
        })
      );
    }
  };

  useEffect(() => {
    setActive(lastSavedTab);
  }, [lastSavedTab]);

  const setColors = () => {};

  useEffect(() => {
    let siteInfo = siteId ? `&siteId=${siteId}` : "";
    if (siteId) action.fetchTiersList(dispatch, siteId);

    action.fetchRPSGridData(dispatch, tierId + siteInfo);
  }, [rpssId]);

  const getArrow = (text) => {
    if(text === "G")
      return "arrow-bottom";
    else if(text === "5"){
      const solutionObject = rpsAllData?.vsTabs?.find((data) => data.tab === "5")
      if(solutionObject?.isSaved === true){
        return "arrow-bottom";
      }
      return "arrow-hidden";
    }
    return "arrow-hidden";
  };

  return (
    <>
      <div className="sps-container">
        <Popup
          visible={true}
          onHiding={() => closeShift(false)}
          dragEnabled={false}
          showCloseButton={true}
          showTitle={true}
          titleRender={renderTitle}
          width={1500}
        >
          <div style={{ height: "100%" }}>
            <div style={{ height: "70px" }}>
              <div className="sps-step-menu">
                {spsSteps.map((d) => (
                  <>
                    <div className="sps-block">
                      <div>
                        <div className="sps-title">{d.title}</div>
                        <div
                          className={
                            d.txt === "G" || d.txt === "5"
                              ? getArrow(d.txt)
                              : d.isSaved
                              ? "arrow-bottom"
                              : "arrow-hidden"
                          }
                        >
                          <i class="arrow down"></i>
                        </div>
                      </div>
                      {(spsSteps[0].isOpen == true || problemSolvingData) && (
                        <div
                          key={d.id}
                          id={"sps_id_" + d.id}
                          className={
                            "sps-step-btn " + isActive(d) + getState(d)
                          }
                          onClick={() => onStepNav(d.id)}
                        >
                          <div className="sps-step dx-fa-button-icon">
                            {d.txt}
                          </div>
                          {/* <Tooltip
                          target={"#" + "sps_id_" + d.id}
                          showEvent="mouseenter"
                          hideEvent="mouseleave"
                        >
                          {" "}
                          <div className="dx-fa-button-icon">{d.title}</div>
                        </Tooltip> */}
                        </div>
                      )}
                    </div>
                  </>
                ))}
              </div>
            </div>
            <div style={{ height: "90%" }}>
              <Position at="center" my="center" />
              <div style={{ width: "100%" }}>
                <div className="sps-content">
                  <div>{spsContent[active]}</div>
                </div>

                <div className="sps-footer">
                  {/* <Button style={{ "marginRight": "14px" }} onClick={saveSps} text="Save" type="normal" /> */}
                  <Button
                    type="normal"
                    icon="fas fa-chevron-left"
                    onClick={movePrev}
                  />
                  <Button
                    type="normal"
                    icon="fas fa-chevron-right"
                    onClick={moveNext}
                  />
                </div>
              </div>
            </div>
          </div>
        </Popup>
      </div>
      {isPreview && <PreviweSps />}
    </>
  );
};
